<div class="input-description">
  <span *ngIf="label" class="input-description__label">{{ label }}</span>
  <ng-content></ng-content>
</div>
